import { Helmet } from 'react-helmet-async';
import { getBaseUrl, withTrailingSlash } from 'src/utils/base-url.util';

export function DefaultSEO() {
  const title = 'Trackgood Product and Brand Transparency and Journeys';
  const desc = 'Verified sustainability, origin and green claims powered by Blockchain and AI';
  const base = getBaseUrl();
  const canon = withTrailingSlash(base);
  const image = `${base}/android-chrome-512x512.png`;

  return (
    <Helmet defaultTitle={title} titleTemplate="%s">
      {/* Core */}
      <meta id="default-seo__components-seo__meta__l14" name="description" content={desc} />
      <link id="default-seo__components-seo__link__l15" rel="canonical" href={canon} />

      {/* OG */}
      <meta id="default-seo__components-seo__meta__l18" property="og:site_name" content="Trackgood Journey" />
      <meta id="default-seo__components-seo__meta__l19" property="og:type" content="website" />
      <meta id="default-seo__components-seo__meta__l20" property="og:title" content={title} />
      <meta id="default-seo__components-seo__meta__l21" property="og:description" content={desc} />
      <meta id="default-seo__components-seo__meta__l22" property="og:url" content={canon} />
      <meta id="default-seo__components-seo__meta__l23" property="og:image" content={image} />
      <meta id="default-seo__components-seo__meta__l24" property="og:image:width" content="512" />
      <meta id="default-seo__components-seo__meta__l25" property="og:image:height" content="512" />

      {/* Twitter */}
      <meta id="default-seo__components-seo__meta__l28" name="twitter:card" content="summary_large_image" />
      <meta id="default-seo__components-seo__meta__l29" name="twitter:title" content={title} />
      <meta id="default-seo__components-seo__meta__l30" name="twitter:description" content={desc} />
      <meta id="default-seo__components-seo__meta__l31" name="twitter:image" content={image} />
    </Helmet>);

}